import { Grid, withWidth, Typography } from "@material-ui/core";
import React, { useEffect} from "react";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import OfferBg from "../../../../../assert/images/offer-bg.png";
import HPCImage from "../../../../../assert/images/HPCImage.webp";
import NISTBadge from "../../../../../assert/images/NISTBadge.webp";
import engineering_objectives from "../../MXRAAS/assets/offering-illustratios/Engineering Objectives.svg";
import {Stack} from "@mui/material";
import design_architecting from "../../MXRAAS/assets/offering-illustratios/Designing & Architecting.svg";
import blueprints from "../../MXRAAS/assets/offering-illustratios/Blueprints.svg";
import usecase_specific from "../../MXRAAS/assets/offering-illustratios/Use-Case-Specific_new.svg";
import uniquely_addressing from "../../MXRAAS/assets/offering-illustratios/Uniquely Addressing.svg";
import facilitating_collaboration from "../../MXRAAS/assets/offering-illustratios/Facilitating Collaboration.svg";
import offering_support from "../../MXRAAS/assets/offering-illustratios/Offering Support.svg";

const ColorButton = styled(Button)(({ theme }) => ({
    color: "#fff",
    backgroundColor: "#502eff",
    width: 150,
    height:40,
    '&:hover': {
        backgroundColor: "#5d28fa",
    },
}));


function Offering(props) {

    let [width, setWidth] = React.useState(window.innerWidth);

    const OfferList = [
        {
            index: 0,
            key: "engineeringObjectives",
            title: "Engineering Objectives",
            subTitle: <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }} >Working with your team to understand your scientific or <span style={{ color: "rgb(80, 46, 255)" }}>Engineering Objectives</span></Typography>,
            desc: "from a conversation that starts with requirements, we tease out the narrative that captures your unique use case"
        },
        {
            index: 1,
            key: "designAndArchitecting",
            title: "Design And Architecting",
            subTitle: <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }}><span style={{ color: "rgb(80, 46, 255)" }}>Design And Architecting</span> a solution that addresses your use case</Typography>,
            desc: "from the broad brushstrokes to the nuances, we craft for discussion our recommended solution",
        },
        {
            index: 2,
            key: "blueprints",
            title: "Blueprints",
            subTitle: <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }}>Framing your use case in terms of one or more implementation <span style={{ color: "rgb(80, 46, 255)" }}>blueprints </span></Typography>,
            desc: "our templating-based approach is both use-case centric and repeatable to ensure your results are reproducible via an easy-to-use portal",
        },
        {
            index: 3,
            key: "useCaseSpecific",
            title: "Use-Case Specific",
            subTitle: <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }}>Offering a value-added ecosystem around your <span style={{ color: "rgb(80, 46, 255)" }}>use-case-specific</span> blueprints</Typography>,
            desc: "with measures of management and analytics, you are ensured visibility into your use of cloud-based resources and their associated costs",
        },
        {
            index: 4,
            key: "uniqueAddressing",
            title: "Unique Addressing",
            subTitle: <Typography  style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }}><span style={{ color: "rgb(80, 46, 255)" }}>Uniquely addressing</span> the sophistication of your use case  </Typography>,
            desc: "from isolated virtual machines with customized software images to HPC clusters crafted specifically for distributed-memory parallel computing, from data and image-processing pipelines to custom, interactive visualization dashboards, isolated applications to involved workflows can be realized",
        },
        {
            index: 5,
            key: "facilitatingCollaboration",
            title: "Facilitating Collaboration",
            subTitle: <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }}><span style={{ color: "rgb(80, 46, 255)" }}>Facilitating collaboration</span></Typography>,
            desc: "within and between teams, units, organizations, scientists and engineers can collaborate efficiently, effectively, and with assurances regarding governance and security",
        },
        {
            index: 6,
            key: "offeringSupport",
            title: "Offering Support",
            subTitle: <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 22 : "2.3vw", }}><span style={{ color: "rgb(80, 46, 255)" }}>Offering support</span></Typography>,
            desc: "from the mundane to the complex, our 24/7/365 support team is available to offer you assistance when you most need it to ensure you remain productive",
        }
    ];
    
    const special = {
        name: "Secure and Compliant Research",
        shortDesc: "Dedicated Secure Research Enclave made available for researchers to use in a secure manner while working on restricted data sets. The solution features robust mechanisms for control over user access to the environment and also over movement of data in or out of scope for analysis so it is ideal for working with restricted data sets.",
        points: [
            "Monitoring and Auditing",
            "NIST 800-171 compliance",
            "Privacy & security that meets industry-specific needs"
        ],
        linkAvailable: true,
        link: ""
    };

    let updateWidthAndHeight = () => {
        setWidth(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener("resize", updateWidthAndHeight);
        return () => window.removeEventListener("resize", updateWidthAndHeight);
    });

    return (
        <React.Fragment>
            <div style={{ backgroundColor: "#051b3f"}} >
                <Grid container direction="column" style={{ justifyContent: "center",alignItems: "center", alignContent: "center"}}>
                    <Grid item xs={12} sm={12} style={{ backgroundColor: "#ffffff", width: "100%"}}>
                        <Grid container style={{ alignItems: props.width === 'xs' ? "normal" : "center"}} direction={props.width === 'xs' ? "column": "row"}>
                            <Grid item xs={10} sm={10}>
                                <div style={{ padding: props.width === 'xs' || props.width === 'sm' ? 25 : 40, margin: props.width === 'sm' ?  "30px 0px 30px 0px" : props.width === 'xs' ? "30px 0px 0px 0px" : 20, paddingLeft: props.width === 'xs' || props.width === 'sm' ? 20 : 64 }}>
                                    <Typography style={{ fontWeight: 700, fontSize: props.width === 'xs' || props.width === 'sm' ? 32 : "2.3vw", color: "rgb(80, 46, 255)", lineHeight: 1 }}>{special.name}</Typography> <br />
                                    <Typography style={{ fontWeight: 400, fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1vw" }}>{special.shortDesc}</Typography>
                                    <ul>
                                        {
                                            special.points.map((point, id) => {
                                                return (
                                                    <li key={id}><Typography style={{fontWeight: 400, fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", lineHeight: 2 }}>{point}</Typography></li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </Grid>
                            <Grid item xs={2} sm={2} >
                                <img src={NISTBadge} alt="NIST Badge"
                                     width={props.width === 'xl' ? "32%" : props.width === 'sm' ? "60%" : props.width === 'xs' ? "100%" : "52%"}
                                     style={{ paddingBottom: props.width === 'xs' ? "8vw": "0vw", marginLeft: props.width === 'xs' ? "8vw": "0vw" }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} style={{ paddingTop: 64, width: "100%"}} ref={props.offerRef}>
                        <Grid container direction="row">
                            <Grid item xs={12} sm={12} md={5} >
                                <Typography style={{ fontWeight: 700, fontSize: props.width === 'xs' || props.width === 'sm' ? 32 : "2.3vw", color: "#ac9bff", lineHeight: 1, paddingLeft: props.width === 'xs' || props.width === 'sm' ? 20 : 80 }}>Capabilities</Typography> <br />
                                <Typography style={{ fontWeight: 500, color: "#fff", fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.3vw", paddingTop: 5, paddingLeft: props.width === 'xs' || props.width === 'sm' ? 20 : 80 }}>ManageX for HPC is a holistic offering available from Terawe that delivers HPC in the cloud</Typography> <br /><br />
                                <Typography style={{ color: "#f1f1f1", fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", paddingLeft: props.width === 'xs' || props.width === 'sm' ? 20 : 80 }}><span style={{ cursor: "pointer", color:"#42ABE9" }} onClick={() => { props.handleMenuClick("requestTrail");}}>Sign up</span> for access to one of our Workspaces.</Typography> <br /><br/>
                                <Typography style={{ color: "#f1f1f1", fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", paddingLeft: props.width === 'xs' || props.width === 'sm' ? 20 : 80 }}>Take full advantage of the power and scale of global cloud services without disrupting your workflows or breaking your piggybank.  ManageX is your simplified pathway to accelerating your time to results.</Typography> <br /><br/>
                                {/*<Typography style={{ color: "#f1f1f1", fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", paddingLeft: props.width === 'xs' || props.width === 'sm' ? 20 : 80 }}>Select the blueprint, deploy and manage the resources. <span style={{ cursor: "pointer", color:"#42ABE9" }} onClick={() => { props.handleMenuClick("requestTrail"); }}> Learn More</span></Typography>*/}
                                {
                                    props.width !== 'xs' && props.width !== 'sm' ?
                                        <div style={{ display: "flex", justifyContent: "center" }}>  <img src={HPCImage} alt="Offer" width="110%" height="100%" style={{ padding: "6vw"}} /></div> :<></>
                                }
                            </Grid>
                            <Grid item xs={12} sm={12} md={7} style={{ overflowX: "hidden", overflowY: "auto", padding: "16px" }}>

                                {
                                    OfferList.map((data, idx) => {
                                        return (
                                            <div key={idx} style={{ backgroundColor: "#fff", borderRadius: 15, padding: props.width === 'xs' || props.width === 'sm' ? 25 : 40, margin: props.width === 'xs' || props.width === 'sm' ?  "30px 0px 30px 0px" : 20 }}>
                                                {data.subTitle} <br />
                                                <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", lineHeight: 2 }}> {data.desc}</Typography>
                                            </div>)
                                    })
                                }
                                {/*<div style={{ textAlign: "center", paddingTop: 40, paddingBottom: 40 }}>*/}
                                {/*    <ColorButton variant="contained" onClick={() => { props.handleMenuClick("requestTrail");}}>TRY IT NOW!</ColorButton>*/}
                                {/*</div>*/}
                                {props.width === 'xs' || props.width === 'sm' ?
                                    <div style={{ display: "flex", justifyContent: "center" }}>  <img src={HPCImage} alt="Offer" width="110%" height="100%" style={{ padding: "6vw"}} /></div> : <></>
                                }

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>

        </React.Fragment>
    );
}

export default withWidth()(Offering);